export enum Status {
  DRAFT = "draft",
  SELF_ASSESSMENT = "self_assessment",
  DISCUSSION = "discussion",
  FINISHED = "finished",
}

export const statusTranslations: Record<Status, string> = {
  [Status.DRAFT]: "Entwurf",
  [Status.SELF_ASSESSMENT]: "Selbsteinschätzung",
  [Status.DISCUSSION]: "Besprechen",
  [Status.FINISHED]: "Fertig",
};

export function getStatusOptions() {
  return Object.values(Status).map((value) => ({ value, label: statusTranslations[value] }));
}
